module.exports = __webpack_public_path__ + "src/assets/img/share-qzone.e4300aee.png";